module.exports = __webpack_public_path__ + "static/media/TrashCanBlue.529b8db1.svg";